import { IMigrationInfo } from 'shared/types/masters'
import * as React from 'react'
import { IMasterCurricula } from 'infrastructure/api'
import { IUpdateInfo, migrateVersions } from 'shared/api/mutations'
import { openTab } from '../../../Helpers'
import { Box, Button } from '@mui/material'
import { ConfirmCommitButton } from 'shared/ui'

export function CatchupComponent({ infos }: { infos: IMigrationInfo[] }) {
  const [updated, setUpdated] = React.useState<string[]>([])

  function doCatchup(info: IMigrationInfo, prevMaster: IMasterCurricula) {
    if (!info.toVersion) return
    setUpdated((prev) => [...prev, prevMaster.version])
    // migrate the schools from the old version to the version that will
    // soon be migrated to the latest version
    const updateInfo: IUpdateInfo = {
      destinationVersion: {
        treeId: info.toVersion.treeId,
        version: info.toVersion.version,
        name: info.toVersion.name,
        title: info.toVersion.title,
      },
      versionToUpdate: {
        version: prevMaster.version,
        name: prevMaster.name,
      },
    }
    return migrateVersions([updateInfo])
  }

  function goToMapping(info: IMigrationInfo, prevMaster: IMasterCurricula) {
    if (!info.toVersion) return
    openTab(
      `/version_mapping/from/${prevMaster.treeId}:${prevMaster.version}/to/${info.toVersion.treeId}:${info.toVersion.version}`,
    )
  }

  if (!infos.length) return null

  return (
    <Box padding="5px" border={'solid 1px'}>
      <Box>
        <strong>Old Versions With Schools</strong>
      </Box>
      {infos.map((info) => {
        return (
          <Box key={info.toVersion!.treeId}>
            {info.oldVersionsWithSchools.map((v) => {
              return (
                <Box key={v.name}>
                  <ConfirmCommitButton
                    disabled={updated.includes(v.version)}
                    onClick={() => doCatchup(info, v)}
                  >
                    <>
                      {v.title}: {v.name}
                    </>
                  </ConfirmCommitButton>
                  <Button onClick={() => goToMapping(info, v)}>Mapping</Button>
                </Box>
              )
            })}
          </Box>
        )
      })}
    </Box>
  )
}
